<div class="row">
  <!-- ifConditionType -->
  <div class="tw-w-full">
    <enum-select-search
      enumName="TextParserIfConditionType"
      [control]="form?.get('ifConditionType')"
      [label]="fields + 'ifConditionType'"
      [value]="ifConditionType"
      (valueChange)="onChangeIfConditionType($event, false)"
    >
    </enum-select-search>
  </div>

  <!-- ifConditionValue -->
  <div class="tw-w-full" *ngIf="isShowIfConditionValue">
    <form-field
      class="tw-w-full"
      [(value)]="ifConditionValue"
      (valueChange)="onChangeIfConditionValue($event)"
      [control]="form?.get('ifConditionValue')"
      [label]="fields + 'ifConditionValue'"
      [type]="isOnlyNumber ? 'tel' : 'text'"
      [isOnlyNumber]="isOnlyNumber"
      [classList]="isOnlyNumber ? 'dir-ltr' : 'dir-rtl'"
    >
    </form-field>
  </div>

  <!-- senderPhonebook -->
  <div *ngIf="isShowUsePhonebook" class="tw-w-full">
    <phonebook-select-search
      type="phonebooksListForServices"
      label="common.group"
      [control]="form?.get('phonebookId')"
      [(value)]="model.phonebookId"
      (valueChange)="onCreateJson()"
    >
    </phonebook-select-search>
  </div>

  <!-- contactFieldName -->
  <div *ngIf="isShowUsePhonebook" class="tw-w-full">
    <contact-column-select-search
      label="common.field"
      [control]="form?.get('phonebookId')"
      [(value)]="model.contactFieldName"
      (valueChange)="onCreateJson()"
      (onError)="onClose()"
    >
    </contact-column-select-search>
  </div>

  <!-- ipAndPort -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.ipAndPort"
      (valueChange)="onCreateJson()"
      [control]="form?.get('ipAndPort')"
      [label]="fields + 'ipAndPort'"
      classList="dir-ltr"
    >
    </form-field>
  </div>

  <!-- userName -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.userName"
      (valueChange)="onCreateJson()"
      [control]="form?.get('userName')"
      label="common.userName"
      classList="dir-ltr"
    >
    </form-field>
  </div>

  <!-- password -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.password"
      (valueChange)="onCreateJson()"
      [control]="form?.get('password')"
      label="common.password"
      classList="dir-ltr"
    >
    </form-field>
  </div>

  <!-- database -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.database"
      (valueChange)="onCreateJson()"
      [control]="form?.get('database')"
      label="common.database"
    >
    </form-field>
  </div>

  <!-- table -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.table"
      (valueChange)="onCreateJson()"
      [control]="form?.get('table')"
      label="common.table"
    >
    </form-field>
  </div>

  <!-- field -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseDataBaseTable">
    <form-field
      class="tw-w-full"
      [(value)]="model.field"
      (valueChange)="onCreateJson()"
      [control]="form?.get('field')"
      label="common.field"
    >
    </form-field>
  </div>

  <!-- apiAddress -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseTokenService">
    <form-field
      class="tw-w-full"
      [(value)]="model.apiAddress"
      (valueChange)="onCreateJson()"
      [control]="form?.get('apiAddress')"
      label="common.apiAddress"
      classList="dir-ltr"
    >
    </form-field>
  </div>

  <!-- token -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseTokenService">
    <form-field
      class="tw-w-full"
      [(value)]="model.token"
      (valueChange)="onCreateJson()"
      [control]="form?.get('token')"
      label="common.token"
      classList="dir-ltr"
    >
    </form-field>
  </div>

  <!-- authorizationScheme -->
  <div class="lg:tw-w-1/2" *ngIf="isShowUseTokenService">
    <enum-select-search
      enumName="HttpAuthorizationScheme"
      label="common.authorizationScheme"
      [control]="form?.get('authorizationScheme')"
      [(value)]="model.authorizationScheme"
      (valueChange)="onCreateJson()"
      (onError)="onClose()"
    >
    </enum-select-search>
  </div>
</div>
